const nettyWorthProxyAddress = process.env.NEXT_PUBLIC_NETTYWORTH_PROXY_ADDRESS!;
const loanManagerAddress = process.env.NEXT_PUBLIC_LOAN_MANAGER_ADDRESS!;
const vaultAddress = process.env.NEXT_PUBLIC_VAULT_ADDRESS;
const whiteListAddress = process.env.NEXT_PUBLIC_WHITE_LIST_ADDRESS!;

export { nettyWorthProxyAddress, loanManagerAddress, vaultAddress, whiteListAddress };
